import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UserQueryParams, UserRead } from "@/domains/user";
import { UserService } from "@/domains/user/services";
import { UserCategory } from "@/domains/user";
import { RootState } from "@/stores";

interface OperatorManageTenantState {
  loading: boolean;
  queryParams: UserQueryParams;
  tenants: UserRead[];
}

const initialState: OperatorManageTenantState = {
  loading: false,
  queryParams: {},
  tenants: [],
};

export const operatorManageTenantSelects = {
  loading: (state: RootState) => state.operatorManageTenant.loading,
  queryParams: (state: RootState) => state.operatorManageTenant.queryParams,
  tenants: (state: RootState) => state.operatorManageTenant.tenants,
};

export const operatorManageTenantThunks = {
  list: createAsyncThunk(
    "operatorManageTenant/list",
    async (params: UserQueryParams = {}) => {
      const res = await UserService.list({
        ...params,
        category: UserCategory.TenantAccount,
        fields: "balances",
      }).run();

      return res.data.msg;
    },
  ),
};

export const operatorManageTenantSlice = createSlice({
  name: "operatorManageTenant",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<UserQueryParams>) => {
      state.queryParams = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorManageTenantThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorManageTenantThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.tenants = action.payload.users;
      },
    );
    builder.addCase(operatorManageTenantThunks.list.rejected, (state) => {
      state.loading = false;
      state.tenants = [];
    });
  },
});

export const operatorManageTenantActions = operatorManageTenantSlice.actions;
